import { useMemo } from 'react';
import useScopedTranslation from 'hooks/useScopedTranslation';
import { noClientsDemoI18n } from '../i18n';
import { formatChileDateTime } from './threadUtils';
// Reusa el estilo de burbujas del chat de llamadas.
import '../../../components/Chat2/CallChat2.css';

// Hilo de WhatsApp: burbujas out (nosotros) a la izquierda, in (cliente) a la derecha,
// igual convencion que CallChat2 (Agente izq / Cliente der).
export default function WhatsappThread({ messages }) {
  const { t } = useScopedTranslation(noClientsDemoI18n);
  const items = useMemo(
    () => (Array.isArray(messages) ? messages : []),
    [messages]
  );

  return (
    <div className='chat-container'>
      {items.map((m) => {
        const isOut = String(m.direction || '').toLowerCase() === 'out';
        const hasText = m.messageText && m.messageText.trim();
        const text = hasText
          ? m.messageText
          : m.mediaType
            ? t('nc_th_media').replace('{type}', m.mediaType)
            : t('nc_th_noContent');
        return (
          <div
            key={m.hubspotMessageId}
            className={`chat-message ${isOut ? 'left' : 'right'}`}
          >
            <div className='chat-sender'>
              {isOut ? t('chat_consultant') : t('chat_client')}
              <span className='caption color-gray-600'>
                {' · '}
                {formatChileDateTime(m.occurredAt)}
              </span>
            </div>
            <div className={`chat-bubble ${isOut ? 'agent' : 'client'}`}>
              {text}
            </div>
          </div>
        );
      })}
    </div>
  );
}
